import React from 'react'
import Game from './Game'
import { render, getConfig, initErrorMonitoring } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { createQuestions } from './utils/questions'
import { createCustomization } from '@educaplay/core/utils/customization'

initErrorMonitoring("https://24051b12fd495c2a347b58721b0414b8@o4509038211104768.ingest.de.sentry.io/4510305658798160");

const RELACIONAR_SOUNDS = {
  'relacionar-collect': assetsUrl('RELACIONAR/arrastrar.mp3'),
  'relacionar-selectGroup': assetsUrl('RELACIONAR/bienactivo.mp3'),
  'relacionar-deselect': assetsUrl('RELACIONAR/carga.mp3'),
  'relacionar-load':assetsUrl('RELACIONAR/escalar.mp3'),
  'relacionar-deselectGroup': assetsUrl('RELACIONAR/mover.mp3'),
  'relacionar-correct': assetsUrl('RELACIONAR/correcto.mp3'),
}

const gameImage = assetsUrl("RELACIONAR/logoActivity.png");
const gameTutorialImage = assetsUrl("RELACIONAR/tutorial.gif");
const container = document.getElementById('root');

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const { resources } = settings;
  
  const filteredQuestions = data.PREGUNTAS
    .map((question, index) => ({
      ...question,
      ENUNCIADO: question.ENUNCIADO !== '' ? question.ENUNCIADO : `${texts.specific.group} ${index + 1}`,
      id: index,
      RESPUESTAS: question.RESPUESTAS.filter(response => response.RESPUESTA !== "" || response.MULTIMEDIA),
      groupId: index,
    }))
    .filter((question) => question.RESPUESTAS.length > 0)

  const incorrectAnswers = data.INCORRECTAS_ACTIVO === 'si' ? data.INCORRECTAS.RESPUESTAS.filter(response => response.RESPUESTA !== "" || response.MULTIMEDIA) : [];

  const liveActived = data.NUMERO_INTENTOS_INFINITOS !== "si";

  const questions = createQuestions({filteredQuestions, incorrectAnswers, resources, liveActived});

  initialize({
    lives: data.NUMERO_INTENTOS,
    liveActived,
    hasCountDown: data.MAXIMO === "si",
    globalCountdown: data.TIEMPO,
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showUserAnswer: false,
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    hasBank: true,
    hasInfinityTries: true,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: createCustomization(data)
  });

  const gameTutorial = liveActived ? null :
    {
      image: gameTutorialImage,
      delay: 1750,
      duration: 6500
    };

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        gameTutorial= {gameTutorial}
        texts={texts}
        Game={Game}
        sounds={RELACIONAR_SOUNDS}
        mappers={{
          report: (question) => {
            const isCorrect = question.answer === '' ? false : question.answer && question.checkAnswer(question.answer)

            const formatAnswer = (answer) => {
              return answer.map(card => {
                const cardData = question.grid.find(element => element.id === card);
                const cardGroup = cardData.group === -1 ? 'D' : cardData.group;
                
                return `${cardGroup}_${cardData.originId}`;
              });
            }

            const triesArray = question.tries.map(entry => {
              return {
                s: false,
                i: question.id,
                a: formatAnswer(entry.answer)
              }
            });
            
            const answer = {
              s: isCorrect,
              i: question.id,
              a: formatAnswer(question.answer.answer)
            }

            return [...triesArray, answer];
          }
        }}
      />
    </React.StrictMode>
  ))
}

init();